import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrintMsgBoxComponent } from '../print-msg-box/print-msg-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';

@Component({
  selector: 'app-admit-card',
  templateUrl: './admit-card.component.html',
  styleUrls: ['./admit-card.component.scss']
})
export class AdmitCardComponent implements OnInit {
  InstId: any;
  dialogRef: MatDialogRef<any>;
  constructor(public router: Router, private modalPopupService: ModalpopService, private dialog: MatDialog,public umsService: UmsService,private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.printAll();
  }

  printAll() {
    let data = {};
      data['message'] = 'Select from dropdown';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-box-open';
      this.dialogRef = this.dialog.open(PrintMsgBoxComponent, {
        disableClose: true,
        data,
      });
      this.dialogRef.afterClosed().subscribe(result => {
        if(result.length == 0){
          this.showPopup('No Data Found For This Session')
        }
        else if(result.length > 0){
          this.getSecretData()
          this.getRgId(result[0]['ShId'],result[0]['SnNo'])
        }
      });
  }

  showPopup(message: string) {
    let data = {}
    data['message'] = message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.redirect('home');
    })
  }
  
  getSecretData(){
    this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.InstId = res.projectPharam['ClubPartTrans']
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
  
  AdmitDetails(){
    this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.searchExamForm(res.data[0]['StuCgId'], res.data[0]['StuCoId'], res.data[0]['SessionId'],res.data[0]['StuEmId'])
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  searchExamForm(CgCode, CoCode, SnNo,EmId) {
    this.spinner.show()
    let payload = {};
    payload['SnNo'] = SnNo;
    payload['CoCode'] = CoCode;
    payload['CgCode'] = CgCode;
    payload['EmId'] = EmId;
    this.umsService.SchExmFrm(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  Print(ShId,SnNo){
   
    var filter: any;
    filter = {
     "LoginId": parseInt(sessionStorage.getItem('StudentRGID')),
      "RptCode": 5,
      "InstName": '',
      "InstNo": this.InstId,
      "ShId": ShId,
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": parseInt(sessionStorage.getItem('StudentRGID')),
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": SnNo,
      "Extra1": '',
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  getRgId(ShId,SnNo) {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.searchEmid(res.data[0]['RgId'],ShId,SnNo)
      }
      else {
      }
    })
  }

  searchEmid(RgId,ShId,SnNo) {
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      if(ShId == ''){
        this.Print(res.data[0]['ShId'],SnNo)
      }
      else if(ShId != ''){
        this.Print(ShId,SnNo)
      }
    });
  }
}
